import button, { buttonVariants, ButtonVariantsType } from './button';
import heading, { headingVariants, HeadingVariantsType } from './heading';
import item, { itemVariants, ItemVariantsType } from './item';
import panel, { panelVariants, PanelVariantsType } from './panel';
import type { CSSStandardProperties } from '../../../types/theme';

const accordion = {
  button,
  heading,
  item,
  panel,
};

export const accordionVariants = {
  button: buttonVariants,
  heading: headingVariants,
  item: itemVariants,
  panel: panelVariants,
};

export type AccordionVariantsType = 'button' | 'heading' | 'item' | 'panel';

export interface AccordionType {
  /** The Accordion subcomponent types. */
  Components: Record<AccordionVariantsType, Record<ButtonVariantsType, CSSStandardProperties>>;
  /** The Accordion.Button component types. */
  Button: ButtonVariantsType;
  /** The Accordion.Heading component types. */
  Heading: HeadingVariantsType;
  /** The Accordion.Item component types. */
  Item: ItemVariantsType;
  /** The Accordion.Panel component types. */
  Panel: PanelVariantsType;
}

export default accordion;
